/*  eslint-disable react/prop-types */
import React, { useContext, useMemo } from 'react';
import { Spin } from '@app/ui';
import { SocialBenchmarkingContext } from './SocialBenchmarkingContext';
import StatCard from './StatCard';
import HighlightsRank from './HighlightsRank';
import './SocialBenchmarking.scss';
import { getDateDifference } from '@app/utils/getDateDifference';
import { getPercentageChange } from '@app/utils/getPercentageChange';

const SocBenchHighlights = ({ highlights, isLoading }) => {
    const { selectedAccountGroup, socialMetric, customDateRange } = useContext(
        SocialBenchmarkingContext,
    );
    const selectedAg =
        selectedAccountGroup && selectedAccountGroup.accountGroupId;
    const socialMetricValue = selectedAg
        ? highlights.data?.[selectedAg]?.itemCount
        : null;

    const avgDiff = useMemo(
        () => socialMetricValue - (highlights.average || 0),
        [highlights, selectedAg],
    );

    const rank =
        selectedAccountGroup && selectedAccountGroup.rank
            ? selectedAccountGroup.rank
            : null;
    const previousRank =
        selectedAccountGroup && selectedAccountGroup.previousRank
            ? selectedAccountGroup.previousRank
            : null;
    const totalAccountGroups =
        highlights && highlights.totalWithAccount
            ? highlights.totalWithAccount
            : 0;
    const dateDiff =
        highlights.periodicity === 'weekly'
            ? 7
            : highlights.periodicity === 'monthly'
              ? 30
              : getDateDifference(
                    customDateRange?.startDate,
                    customDateRange?.endDate,
                );

    const trendChange = () => {
        if (!selectedAccountGroup) return '';
        if (socialMetric === 'Followers') {
            return getPercentageChange(
                selectedAccountGroup.followersCountOnCurrentPeriodEndDate,
                selectedAccountGroup.followersCountOnPreviousPeriodEndDate,
            );
        } else if (socialMetric === 'Post Volume') {
            return getPercentageChange(
                selectedAccountGroup.postCountCurrentPeriod,
                selectedAccountGroup.postCountPreviousPeriod,
            );
        } else {
            return getPercentageChange(
                selectedAccountGroup.engagementsCurrentPeriod,
                selectedAccountGroup.engagementsPreviousPeriod,
            );
        }
    };

    return (
        <Spin spinning={isLoading} size="large">
            <div className="highlights-container">
                <div className="stat-cards-container">
                    <StatCard
                        type="total"
                        value={socialMetricValue}
                        hasIcon
                        metric={socialMetric}
                        avgDiff={avgDiff}
                    />
                    <StatCard
                        type="rank"
                        value={rank}
                        allRanked={totalAccountGroups}
                        previousRank={previousRank}
                        dateDiff={dateDiff}
                    />
                    <StatCard
                        type="trend"
                        value={trendChange()}
                        dateDiff={dateDiff}
                        metric={socialMetric}
                    />
                    <StatCard
                        type="average"
                        value={highlights.average}
                        hasIcon
                        metric={socialMetric}
                    />
                </div>
                <HighlightsRank highlights={highlights} />
            </div>
        </Spin>
    );
};

export default SocBenchHighlights;
